import {UiStateActionToasterModel} from "@store/models/ui.model";
import {Confirmation} from "primeng/api";

 
export namespace UiActions {
  export class openSidebar {
    static readonly type = '[Sidebar] Open Sidebar';
    constructor(public payload: string) {}
  }

  export class closeSidebar {
    static readonly type = '[Sidebar] Close Sidebar';
    constructor(public payload: string) {}
  }

  export class toasterShowError {
    static readonly type = '[Toaster] Show Error';
    constructor(public payload: UiStateActionToasterModel) {}
  }

  export class toasterShowWarn {
    static readonly type = '[Toaster] Show Warn';
    constructor(public payload: UiStateActionToasterModel) {}
  }

  export class toasterShowSuccess {
    static readonly type = '[Toaster] Show Success';
    constructor(public payload: UiStateActionToasterModel) {}
  }

  export class toasterShowInfo {
    static readonly type = '[Toaster] Show Info';
    constructor(public payload: UiStateActionToasterModel) {}
  }

  export class toasterClearAll {
    static readonly type = '[Toaster] Clear All';
  }

  export class confirmDialogOpen {
    static readonly type = '[ConfirmDialog] Open';
    constructor(public confirmation: Confirmation) {}
  }

  export class confirmDialogClose {
    static readonly type = '[ConfirmDialog] Close';
  }

  export class openOnScreenInfo {
    static readonly type = '[InfoOnScreen] Open';
  }

  export class closeOnScreenInfo {
    static readonly type = '[InfoOnScreen] Close';
  }

  export class toggleOnScreenInfo {
    static readonly type = '[InfoOnScreen] Toggle';
  }

  export class openAppInfo {
    static readonly type = '[AppInfo] Open';
  }

  export class closeAppInfo {
    static readonly type = '[AppInfo] Close';
  }

  export class toggleStartcodesMasked {
    static readonly type = '[Startcodes] Toggle Masked';
  }

  export class setForbidden403Access {
    static readonly type = '[Forbidden403] Set';
  }

}
